import { Component } from 'js-component-framework';

/**
 * Component for Immersive Block
 */
export default class ImmersiveBlock extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);

    const velocity = 0.03; // Creates the range of movement for the image. 0.03 produces roughly +- 20px.
    const imageContainers = document.querySelectorAll('.immersive-block__image'); // eslint-disable-line max-len

    function runSubtleParallax() {
      [...imageContainers].forEach((imageContainer) => {
        const image = imageContainer.querySelector('img');
        const caption = imageContainer.querySelector('figcaption');
        const vHeight = (window.innerHeight || document.documentElement.clientHeight) + 40; // eslint-disable-line max-len
        const scrollPos = image.getBoundingClientRect();
        const offset = `${Math.round(scrollPos.top * velocity)}px`;

        // If the image is about to enter the viewport or is visible in the viewport.
        if (scrollPos.top <= vHeight && 0 <= scrollPos.bottom) {
          image.style.top = `${offset}`; // eslint-disable-line no-param-reassign

          if (caption) {
            caption.style.top = `${offset}`; // eslint-disable-line no-param-reassign
          }
        }
      });
    }

    window.addEventListener('load', runSubtleParallax);
    window.addEventListener('scroll', runSubtleParallax);
  }
}
